import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './icons/cross.svg'


const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "photo-by" }, [
  /*#__PURE__*/_createTextVNode(" Photo by © "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://bennytache.com" }, "Benny Tache")
], -1)

import { computed, onMounted, Ref, ref, watch } from "vue";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const background_img = ref(2);

const popupError = ref() as Ref<HTMLDivElement>;

const is_error = computed(() => {
  return store.state.errors.length > 0;
});

const reset_errors = () => {
  popupError.value.classList.remove("show-error");
  const timeout = setTimeout(() => {
    store.state.errors = [];
    clearTimeout(timeout);
  }, 750);
};

watch(is_error, () => {
  if (is_error.value) {
    // const timeout = setTimeout(() => {
    // popupError.value.classList.remove("show-error");
    // const timeout2 = setTimeout(() => {
    //   store.state.errors = [];
    //   clearTimeout(timeout2);
    // }, 750);
    // clearTimeout(timeout);
    // }, 10000);
  }
});
onMounted(() => {
  // const interval = setInterval(() => {
  //   const i = Math.round(Math.random() * 7) + 1;
  //   background_img.value = i;
  // }, 15000);
});

const mouseOverHelp = (e, leave) => {
  if (leave) {
    e.target.innerText = "Un problème avec notre site ?";
  } else {
    e.target.innerText = "Contactez nous à antoine@oeilbsolu.ch";
  }
};

const openMailBox = (e) => {
  window.location.href =
    "mailto:antoine@oeilabsolu.ch?subject=Problème oatransfer";
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      class: "background-img",
      src: require(`@/assets/${background_img.value}.jpg`),
      alt: ""
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      ref_key: "popupError",
      ref: popupError,
      class: _normalizeClass(_unref(is_error) == true ? 'popup-error show-error' : 'popup-error')
    }, [
      _createElementVNode("img", {
        class: "remove-error-btn",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (reset_errors()))
      }),
      _createElementVNode("h1", null, _toDisplayString(_unref(store).state.errors[0]), 1)
    ], 2),
    _createVNode(_component_router_view),
    _createElementVNode("footer", null, [
      _hoisted_2,
      _createElementVNode("h3", {
        class: "help",
        onMouseover: _cache[1] || (_cache[1] = (e) => mouseOverHelp(e, false)),
        onMouseleave: _cache[2] || (_cache[2] = (e) => mouseOverHelp(e, true)),
        onClick: openMailBox
      }, " Un problème avec notre site ? ", 32)
    ])
  ], 64))
}
}

})